import { makeStyles } from "@material-ui/core/styles";
import { COLORS } from "../../constants/colors";

export default makeStyles((theme) => ({
  pageContainer: {
    width: "100%",
    margin: "0",
  },
  infoContainer: {
    backgroundColor: `${COLORS.accent}`,
    height: "fit-content",
  },
  headerTitle: {
    fontFamily: "Montserrat",
    textAlign: "center",
    padding: "10px",
  },
  dividerStyle: {
    backgroundColor: "black",
    margin: "0 50px",
  },
  googleMaps: {
    width: "100%",
    height: "350px",
    border: "none",
    padding: "5px 0",
  },
  googleForms: {
    width: "100%",
    height: "1000px",
    border: "none",
    padding: "5px 0",
  },
  contentContainer: {
    padding: "0 25px 10px 25px",
  },
  contentText: {
    fontFamily: "Blinker",
    fontSize: 20
  }
}));
